import React, { createContext, useContext, useState, useEffect } from "react";

const HotkeyContext = createContext(false);

/*
 Provider que escucha la tecla Shift.
 Mientras el usuario mantiene presionado Shift, `mostrarHotkeys` es true.
 */
export const HotkeyProvider = ({ children }) => {
  const [mostrarHotkeys, setMostrarHotkeys] = useState(false);

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "Shift") setMostrarHotkeys(true);
    };
    const onKeyUp = (e) => {
      if (e.key === "Shift") setMostrarHotkeys(false);
    };
    // Si la ventana pierde el foco mientras Shift está presionado, ocultar
    const onBlur = () => setMostrarHotkeys(false);

    window.addEventListener("keydown", onKeyDown);
    window.addEventListener("keyup", onKeyUp);
    window.addEventListener("blur", onBlur);

    return () => {
      window.removeEventListener("keydown", onKeyDown);
      window.removeEventListener("keyup", onKeyUp);
      window.removeEventListener("blur", onBlur);
    };
  }, []);

  return (
    <HotkeyContext.Provider value={mostrarHotkeys}>
      {children}
    </HotkeyContext.Provider>
  );
};

/**
 * Hook para consumir el estado de visibilidad de hotkeys.
 * @returns {boolean} true si se deben mostrar los badges de atajos
 */
export const useMostrarHotkeys = () => useContext(HotkeyContext);

export default HotkeyContext;